module.exports = "https://static.wmbcdn.com/uniweb/images/4126fe4e70ad60035da7826369791371.svg";